import { httpClient } from "@/app/client/httpClient";
import { MessageSenderType } from "@/types/order/MessageSenderType";
import { PageableRequest } from "@/types/PageableRequest";

class MessageService {
  fetchMessages(
    query?: PageableRequest<{
      application: number;
      created_at__gte: string | undefined;
      created_at__lte: string;
      office: number;
      isOffered: boolean;
      worker: string;
      sender_type: MessageSenderType;
      ordering: string;
    }>
  ) {
    return httpClient.orders.office_to_worker_application_messages.$get({
      query
    });
  }

  createMessage(body: {
    text: string;
    isOffered?: boolean;
    worker: string;
    office: number;
  }) {
    return httpClient.orders.office_to_worker_application_messages.$post({
      body
    });
  }

  fetchMessageRooms() {
    return httpClient.orders.message_rooms.workers_list.$get();
  }

  countUnreadMessages(officeId?: number) {
    return httpClient.orders.message_rooms.count_unread_messages_to_worker.$get(
      {
        query: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          office_id: officeId
        }
      }
    );
  }

  readMessages(workerId: string, officeId: number, latestMessageId: number) {
    return httpClient.orders.message_rooms.read_messages_to_worker.$patch({
      body: {
        workerId,
        officeId,
        latestMessageId
      }
    });
  }

  hasMessageRoom(officeId: number) {
    return httpClient.orders.message_rooms.has_message_room.$get({
      query: {
        office_id: officeId
      }
    });
  }
}

export const messageService = new MessageService();
